import _ from 'lodash'
import moment from 'moment'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  legend: {
    margin: '5rem 0',
    fontSize: '13px'
  },

  ledgerLink: {
    marginTop: '5rem',
    display: 'block',
    paddingTop: '5rem',
    borderTop: '1px solid #eee',
  },

  intro: {
    marginTop: '0'
  },

  info: {
    display: 'flex',
    justifyContent: 'center',

    '& b': {
      whiteSpace: 'nowrap'
    },

    '& p': {
      marginBottom: '0',

      '& + p': {
        borderLeft: '1px solid #aaa',
        paddingLeft: '6px',
        marginLeft: '6px'
      }
    }
  }
})

class Legend extends Component {
  render() {
    const { classes } = this.props

    return (
      <div className="container">
        <div className={classes.legend}>
          <p className={classes.intro}>The fee is calculated based on the following assumptions</p>
          <div className={classes.info}>
            <p>BTC price: <b>${_.round(this.props.btcPrice, 2)}</b></p>
            <p>Transaction size: <b>225 bytes</b></p>
            <p>Latest update: <b>{moment(this.props.lastUpdate).local().format('HH:mm:ss')}</b></p>
          </div>
          <a className={classes.ledgerLink} target="_blank" rel="noopener noreferrer" href="https://www.ledgerwallet.com/r/8fac?path=/products/ledger-nano-s&tracker=bitcoinfees">
            <img width="728" height="90" alt="Ledger Nano S - The secure hardware wallet" src="http://www.ledgerwallet.com/affiliate/image/728/90" />
          </a>
        </div>
      </div>
    )
  }
}

Legend.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Legend)



// WEBPACK FOOTER //
// ./src/Legend.js